<template>
  <article>
    <div class="box">
      <div class="columns">
        <div class="column is-1 has-text-centered">
          <small><strong> #{{ fn.rank }} </strong></small>

          <span v-if="fn.rankChange">
            <br>
            <span class="is-size-7" :class="fnRankChangeClass(fn.rankChange)">
              <span v-if="fn.rankChange > 0" class="is-danger">
                <i class="fa fa-arrow-up" aria-hidden="true"></i>
              </span>
              <span v-else-if="fn.rankChange < 0" class="is-danger">
                <i class="fa fa-arrow-down" aria-hidden="true"></i>
              </span>
              {{ fn.rankChange | absval }}
            </span>
          </span>
        </div>
        <div class="column is-8">
          <p>
            <router-link class="hotpath-link" :to="{ name: 'HotpathDrilldown', query: { name: fn.name } }">
              <span v-bind:class="fnNameClass(fn.name)">
                {{ fn.name }}
              </span>
            </router-link>
            <br>

            <progress class="progress is-info" :value="fn.percentage" max="100">
              {{ fn.percentage }} %
            </progress>

            {{ fn.percentage | percentage }} active
          </p>
        </div>

        <div class="column has-text-centered">
          <br>
          <span v-if="fn.percentageChange" class="tag" :class="fnTempClass(fn.percentageChange)">
            <i class="fas" v-bind:class="fnIconClass(fn.percentageChange)"></i>
            &nbsp; {{ fnChangeMessage(fn.percentageChange) }}
          </span>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import Vue from "vue";

var numeral = require("numeral");

Vue.filter("absval", value => {
  if (value < 0) {
    return -value;
  }
  return value;
});

export default {
  name: "SingleFunctionCard",
  props: {
    fn: {
      type: Object,
      required: true
    }
  },
  methods: {
    fnNameClass(name) {
      return {
        "is-5": name.length < 25,
        "is-6": name.length < 35,
        "is-7": name.length >= 35
      };
    },
    fnTempClass(value) {
      return {
        "is-danger": value > 0,
        "is-info": value < 0
      };
    },
    fnRankChangeClass(value) {
      return {
        "has-text-danger": value > 0,
        "has-text-info": value < 0
      };
    },
    fnIconClass(pctChange) {
      return {
        "fa-fire": pctChange > 0,
        "fa-snowflake": pctChange < 0
      };
    },
    fnChangeMessage(pctChange) {
      var trunc = numeral(pctChange).format("0.0");
      if (pctChange > 0) {
        if (trunc == 0.0) {
          trunc = 0.1;
        }
        return "Hotter: +" + trunc + "%";
      }

      if (trunc == 0.0) {
        trunc = -0.1;
      }
      return "Colder: " + trunc + "%";
    }
  }
};
</script>

<style>
.hotpath-link {
  color: black;
}
</style>
